export default "__VITE_ASSET__BuyzdaM0__"